import { render, staticRenderFns } from "./ContactBlock.vue?vue&type=template&id=b5d34290&scoped=true&"
import script from "./ContactBlock.vue?vue&type=script&lang=ts&"
export * from "./ContactBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ContactBlock.vue?vue&type=style&index=0&id=b5d34290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d34290",
  null
  
)

export default component.exports